import React, { useState, useEffect, useCallback } from "react";
import {
  DefaultButton,
  PrimaryButton,
  IconButton,
} from "@fluentui/react/lib/Button";
import moment from "moment";
import { Modal } from "@fluentui/react/lib/Modal";
import {
  getTheme,
  mergeStyleSets,
  mergeStyles,
} from "@fluentui/react/lib/Styling";
import "bootstrap/dist/css/bootstrap.min.css";
import currentstage from "../../../../assets/img/currentstage.svg";
// Added By Madhuri.K On 08-07-2025
import DelegatedTo from "../../../../assets/img/Assign_TO.svg";
import useSubmitAction from "../../../hooks/Editpage/useSubmitAction";
// Added By Madhuri.K On 09-10-2025
import TimelineIcon from "@mui/icons-material/Timeline";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
// Added By Madhuri.K On 09-10-2025 - Icons for action buttons
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import UndoIcon from "@mui/icons-material/Undo";
import SendIcon from "@mui/icons-material/Send";
import CancelIcon from "@mui/icons-material/Cancel";
import SaveIcon from "@mui/icons-material/Save";
import DraftsIcon from "@mui/icons-material/Drafts";
import axios from "axios";
import { toast } from "react-toastify";
import { Stack, Image, TextField, Dropdown, DatePicker } from "@fluentui/react";
// Added by Gauri to fix dropdown position issue on 20 Nov 2025
import { DirectionalHint } from "@fluentui/react";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import InitiativeDetailsModal from "app/views/InitiativeManagement/InitiativeDetailsModal";
import { ImageFit } from "@fluentui/react/lib/Image";
import PrioritizationCheckList from "./PrioritizationCheckList";
import WorkflowInfo from "./WorkflowInfo";
import ActionItems from "./ActionItem";
// Divider Added By Madhuri.K On 08-07-2025
import { Divider, Tooltip } from "@mui/material";
import "./basicDetailEdit.css";
import CloseIcon from "@mui/icons-material/Close";
import WorkflowDrawer from "./WorkflowDrawer";
import InitiativeHistoryDrawer12 from "./InitiativeHistoryDrawer12";
import AxiosInstance1 from "app/hooks/AxiosInstance/AxiosInstance1";
// Added By Madhuri.K On 08-07-2025
import DelegatedAccessModal from "./DelegatedAccessModal";
const theme = getTheme();

const profilePictureContainerStyles = mergeStyles({
  position: "relative",
  display: "inline-block",
});

const editIconStyles = mergeStyles({
  position: "absolute",
  bottom: 0,
  right: 0,
  // backgroundColor: "#ffffff",
  borderRadius: "50%",
  cursor: "pointer",
  padding: 5,
  fontSize: 24,
  color: "#000000",
  zIndex: 10,
});

const buttonGroupStyles = mergeStyles({
  position: "absolute",
  top: 20,
  right: 20,
  zIndex: 10,
});

const profilePictureStyles = mergeStyles({
  borderRadius: "50%",
  width: 72,
  height: 72,
  objectFit: "cover",
  border: "2px solid #e1dfdd",
});

const fieldContainerStyles = mergeStyles({
  display: "flex",
  alignItems: "flex-start",
  gap: 20,
});

const fieldGroupStyles = mergeStyles({
  flexBasis: "48%",
});
const classNames = mergeStyleSets({
  modalWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)", // backdrop effect
  },
  modal: {
    width: "40vw",
    maxHeight: "80vh",
    backgroundColor: theme.palette.white, // Ensure modal has a white background
    padding: theme.spacing.m,
    borderRadius: theme.effects.roundedCorner2,
    boxShadow: theme.effects.elevation16,
    overflowY: "auto",
    position: "relative", // For the close button
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: `${theme.spacing.s1} ${theme.spacing.m}`,
    borderBottom: `1px solid ${theme.palette.neutralLight}`,
  },
  body: {
    padding: theme.spacing.m,
  },
  footer: {
    display: "flex",
    justifyContent: "flex-end",
    padding: `${theme.spacing.s1} ${theme.spacing.m}`,
    borderTop: `1px solid ${theme.palette.neutralLight}`,
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing.s1,
    top: theme.spacing.s1,
  },
});

{
  /* Passed initiativesData by Gauri for manage workflow stages on 24 Mar 2025 */
}
function BasicDetailEdit({
  initiativesID,
  image,
  // Added By Madhuri.K On 08-07-2025
  natureofDemandID,
  natureOfDemandRevisionID,
  natureofDemand,
  initiativeLinkAccess,
  initiativeDetail = {},
  handleFieldChange,
  handleGoBack,
  setRefresh1,
  refresh,
  refresh12,
  setRefresh12,
  prioritizationCheckList,
  initiativeActioItems,
  initiativesData,
  setInitiativeDetail,
}) {
  const [formDataState, setFormDataState] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [comments, setComments] = useState("");
  const [loading, setLoading] = useState(false); // Loading state for the submit button
  const { submitAction, loading1 } = useSubmitAction();
  const [openDetailsModal, setOpenDetailsModal] = useState(false);
  // Added By Madhuri.K On 08-07-2025
  const [DelegatedToModal, setDelegatedToModal] = useState(false);
  // Assuming these are fetched from somewhere, hardcoded for now:
  const ideaID = initiativesID;
  let pimage = "";
  const userdata = JSON.parse(sessionStorage.getItem("user"));
  const employeeId = userdata?.employeeId;
  const userID = userdata?.employeeId;
  const [aopen, setAOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const [open1, setOpen1] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [initiativeWorkFlow, setInitiativeWorkFlow] = useState();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [selectedInitiativeId, setSelectedInitiativeId] = useState(null);
  // const [iniData, setIniData] = useState(null);
  const [stageDetails, setStageDetails] = useState(null);
  const [isFormInitialized, setIsFormInitialized] = useState(false);
  const [businessUnitData, setBusinessUnitData] = useState([]);
  const [deliveryUnitData, setDeliveryUnitData] = useState([]);
  const [deliveryTeamData, setDeliveryTeamData] = useState([]);
  // Added By Madhuri.K On 31-10-2025 - Cache full BG→OU→DU→DT tree (similar to UserMaintenance)
  const [bgTree, setBgTree] = useState([]);
  // const NodID = initiativesData?.natureofDemandID;
  // const NodRevID = initiativesData?.natureOfDemandRevisionID;
  const handleOpenDrawer = () => {
    setIsDrawerOpen(true);
  };

  const handleCloseDrawer = () => {
    setIsDrawerOpen(false);
  };
  // Added By Madhuri.K On 31-10-2025 - Track initiativeDetail changes to re-initialize after save
  // This state tracks changes to initiativeDetail so we can re-initialize dropdowns when data is refreshed after save
  const [prevInitiativeDetailKey, setPrevInitiativeDetailKey] = useState(null);

  // Added By Madhuri.K On 31-10-2025 - Modified form initialization to detect changes after save/refresh
  // Removed old condition that only checked isFormInitialized, now tracks actual data changes
  useEffect(() => {
    if (!initiativeDetail?.data?.listInitiativeDetailEntity) return;

    // Added By Madhuri.K On 31-10-2025 - Create a key to track if initiativeDetail has changed (for refresh after save)
    const currentKey = JSON.stringify(
      initiativeDetail.data.listInitiativeDetailEntity.map((f) => ({
        name: f.actualFieldName,
        value: f.controlValue,
      }))
    );

    // Added By Madhuri.K On 31-10-2025 - If this is the first load or data has changed, re-initialize
    if (!prevInitiativeDetailKey || prevInitiativeDetailKey !== currentKey) {
      // Added By Madhuri.K On 31-10-2025 - Reset form initialization flag when data changes (after save)
      // This ensures dependent dropdowns are re-populated after save/refresh
      setIsFormInitialized(false);

      const initialData = {};
      initiativeDetail.data.listInitiativeDetailEntity.forEach((field) => {
        const { actualFieldName, controlValue } = field;

        if (actualFieldName.includes("Date") && controlValue) {
          // const parsedDate = moment(controlValue, [
          //   "MMM D YYYY h:mmA",
          //   moment.ISO_8601,
          // ]);
          // initialData[actualFieldName] = parsedDate.isValid()
          //   ? parsedDate.toISOString()
          //   : controlValue;

          // const parsedDate = controlValue
          //   ? moment(controlValue, [
          //     "YYYY-MM-DDTHH:mm:ss.SSSZ",
          //     "MMM DD YYYY h:mmA",
          //   ])
          //     .startOf("day")
          //     .utc()
          //     .toDate()
          //   : null;

          const parsedDate = controlValue
            ? moment
              .utc(
                controlValue,
                ["YYYY-MM-DDTHH:mm:ss.SSSZ", "MMM DD YYYY h:mmA"] // Handle both formats
              )
              .isValid()
              ? moment
                .utc(
                  controlValue,
                  ["YYYY-MM-DDTHH:mm:ss.SSSZ", "MMM DD YYYY h:mmA"] // Use same formats
                )
                .toDate()
              : null
            : null;

          initialData[actualFieldName] = parsedDate ? parsedDate : controlValue;
        } else {
          initialData[actualFieldName] = controlValue || "";
        }
      });

      // Added By Madhuri.K On 31-10-2025 - Update form state with refreshed data
      setFormDataState(initialData);
      setIsFormInitialized(true);
      // Added By Madhuri.K On 31-10-2025 - Track the current state to detect future changes
      setPrevInitiativeDetailKey(currentKey);
    }
  }, [initiativeDetail, setRefresh12, prevInitiativeDetailKey]);

  // Added By Madhuri.K On 31-10-2025 - Helper function to update dropdown options in initiativeDetail structure
  const updateDropdownOptions = useCallback((fieldName, options) => {
    setInitiativeDetail((prevData) => {
      if (!prevData?.data?.listInitiativeDetailEntity) return prevData;

      const currentItem = prevData.data.listInitiativeDetailEntity.find(
        (item) => item.actualFieldName === fieldName
      );

      const existingDropdown = currentItem?.initiativeDetailDropDownEntity || [];
      const existingString = JSON.stringify(existingDropdown);
      const newString = JSON.stringify(options);

      if (existingString === newString) return prevData;

      const updatedList = prevData.data.listInitiativeDetailEntity.map(
        (item) =>
          item.actualFieldName === fieldName
            ? {
              ...item,
              initiativeDetailDropDownEntity: options,
            }
            : item
      );

      return {
        ...prevData,
        data: {
          ...prevData.data,
          listInitiativeDetailEntity: updatedList,
        },
      };
    });
  }, []);

  // Added By Madhuri.K On 31-10-2025 - Initialize dependent dropdown options when form loads with existing data
  // This effect runs when initiativeDetail changes (including after save/refresh) and when bgTree is loaded
  // Added initiativeDetail to dependency array to ensure dropdowns are re-populated after save/refresh
  useEffect(() => {
    if (!isFormInitialized || !bgTree || bgTree.length === 0) return;

    const businessUnitID = formDataState["BusinessUnitID"];
    const organizationUnitID = formDataState["OrganizationUnit"];
    const deliveryUnitID = formDataState["DeliveryUnit"];

    // Populate OrganizationUnit dropdown based on existing BusinessUnitID
    if (businessUnitID) {
      const bgNode = bgTree.find((b) => String(b.businessGroupID) === String(businessUnitID));
      if (bgNode) {
        const ouNodes = bgNode?.listOrganizationUnitEntity || [];
        const ou = ouNodes.map((ou) => ({
          fieldName: "OrganizationUnit",
          id: String(ou.locationID),
          name: String(ou.location),
        }));

        setDeliveryUnitData(ouNodes);
        updateDropdownOptions("OrganizationUnit", ou);

        // Populate DeliveryUnit dropdown based on existing OrganizationUnit
        if (organizationUnitID && ouNodes.length > 0) {
          const ouNode = ouNodes.find((o) => String(o.locationID) === String(organizationUnitID));
          if (ouNode) {
            const duNodes = ouNode?.listDeliveryUnitEntity || [];
            const du = duNodes.map((du) => ({
              fieldName: "DeliveryUnit",
              id: String(du.resourcePoolID),
              name: String(du.resourcePoolName || du.resourcePoolName),
            }));

            setDeliveryTeamData(duNodes);
            updateDropdownOptions("DeliveryUnit", du);

            // Populate DeliveryTeam dropdown based on existing DeliveryUnit
            if (deliveryUnitID && duNodes.length > 0) {
              const duNode = duNodes.find((u) => String(u.resourcePoolID) === String(deliveryUnitID));
              if (duNode) {
                const dtNodes = duNode?.listDeliveryTeamEntity || [];
                const dt = dtNodes.map((dt) => ({
                  fieldName: "DeliveryTeam",
                  id: String(dt.groupID),
                  name: String(dt.groupName),
                }));

                updateDropdownOptions("DeliveryTeam", dt);
              }
            }
          }
        }
      }
    }
  }, [isFormInitialized, bgTree, formDataState["BusinessUnitID"], formDataState["OrganizationUnit"], formDataState["DeliveryUnit"], updateDropdownOptions, initiativeDetail]);

  // Removed By Madhuri.K On 31-10-2025 - Old fetchBusineesDDL function replaced with fetchBGOUDUDT to match UserMaintenance pattern
  // Added By Madhuri.K On 31-10-2025 - Refactored Refer UserMaintenance page for dependent dropdowns
  // Unified BG/OU/DU/DT loader using GetBGOUDUDT API (similar to UserMaintenance)
  const fetchBGOUDUDT = async ({ businessGroupId = 0, organizationUnitId = 0, deliveryUnitId = 0 } = {}) => {
    try {
      const res = await AxiosInstance1.get('/api/InitiativeListFilter/GetBGOUDUDT');
      const d = res?.data?.data || {};

      // Prefer nested shape mapping if present
      if (Array.isArray(d.listBusinessGroupEntity)) {
        const tree = d.listBusinessGroupEntity;
        setBgTree(tree);
        const bg = (tree || []).map((bg) => ({ key: String(bg.businessGroupID), text: String(bg.businessGroup) }));
        setBusinessUnitData(tree);

        let ou = [];
        let du = [];
        let dt = [];

        if (businessGroupId) {
          const bgNode = tree.find((b) => String(b.businessGroupID) === String(businessGroupId));
          const ouNodes = bgNode?.listOrganizationUnitEntity || [];
          ou = ouNodes.map((ou) => ({ key: String(ou.locationID), text: String(ou.location) }));

          if (organizationUnitId) {
            const ouNode = ouNodes.find((o) => String(o.locationID) === String(organizationUnitId));
            const duNodes = ouNode?.listDeliveryUnitEntity || [];
            du = duNodes.map((du) => ({ key: String(du.resourcePoolID), text: String(du.resourcePoolName || du.resourcePoolName) }));

            if (deliveryUnitId) {
              const duNode = duNodes.find((u) => String(u.resourcePoolID) === String(deliveryUnitId));
              const dtNodes = duNode?.listDeliveryTeamEntity || [];
              dt = dtNodes.map((dt) => ({ key: String(dt.groupID), text: String(dt.groupName) }));
            }
          }
        }

        return { bg, ou, du, dt };
      }

      // Fallback to flat-list mapping if API returns that shape
      const bg = (d.listBusinessGroupEntity || []).map((bg) => ({ key: String(bg.businessGroupID), text: String(bg.businessGroup) }));
      setBusinessUnitData(d.listBusinessGroupEntity || []);
      return { bg: bg, ou: [], du: [], dt: [] };
    } catch (e) {
      console.warn('GetBGOUDUDT failed', e);
      return { bg: [], ou: [], du: [], dt: [] };
    }
  };

  useEffect(() => {
    fetchBGOUDUDT();
  }, []);

  // Removed By Madhuri.K On 31-10-2025 - Old useEffect that handled dependent dropdown updates (lines 275-482) replaced with handler functions

  // Added By Madhuri.K On 31-10-2025 - Cascade handlers (similar to UserMaintenance)
  const handleBusinessGroupChange = async (selectedBG) => {
    console.log('Business Group changed to:', selectedBG);

    // Clear dependent field values
    setFormDataState((prev) => ({
      ...prev,
      OrganizationUnit: '',
      DeliveryUnit: '',
      DeliveryTeam: ''
    }));

    // Clear dependent dropdowns
    updateDropdownOptions("OrganizationUnit", []);
    updateDropdownOptions("DeliveryUnit", []);
    updateDropdownOptions("DeliveryTeam", []);

    // Use cached tree if available to avoid flicker; otherwise fetch
    if (bgTree && bgTree.length) {
      const bgNode = bgTree.find((b) => String(b.businessGroupID) === String(selectedBG));
      const ouNodes = bgNode?.listOrganizationUnitEntity || [];
      const ou = ouNodes.map((ou) => ({
        fieldName: "OrganizationUnit",
        id: String(ou.locationID),
        name: String(ou.location),
      }));

      setDeliveryUnitData(ouNodes);
      updateDropdownOptions("OrganizationUnit", ou);
    } else {
      const { ou: ouList = [] } = await fetchBGOUDUDT({ businessGroupId: selectedBG || 0 });
      const ouOptions = ouList.map((ou) => ({
        fieldName: "OrganizationUnit",
        id: ou.key,
        name: ou.text,
      }));
      updateDropdownOptions("OrganizationUnit", ouOptions);
    }
  };

  const handleOrgUnitChange = async (selectedOU, businessGroupID) => {
    console.log('Organization Unit changed to:', selectedOU);
    const bgForChain = businessGroupID || formDataState["BusinessUnitID"] || '';

    // Clear dependent field values
    setFormDataState((prev) => ({
      ...prev,
      DeliveryUnit: '',
      DeliveryTeam: ''
    }));

    // Clear dependent dropdowns
    updateDropdownOptions("DeliveryUnit", []);
    updateDropdownOptions("DeliveryTeam", []);

    // Use cached tree if available to avoid flicker; otherwise fetch
    if (bgTree && bgTree.length && bgForChain) {
      const bgNode = bgTree.find((b) => String(b.businessGroupID) === String(bgForChain));
      const ouNodes = bgNode?.listOrganizationUnitEntity || [];
      const ouNode = ouNodes.find((o) => String(o.locationID) === String(selectedOU));
      const duNodes = ouNode?.listDeliveryUnitEntity || [];
      const du = duNodes.map((du) => ({
        fieldName: "DeliveryUnit",
        id: String(du.resourcePoolID),
        name: String(du.resourcePoolName || du.resourcePoolName),
      }));

      setDeliveryTeamData(duNodes);
      updateDropdownOptions("DeliveryUnit", du);
    } else {
      const { du: duList = [] } = await fetchBGOUDUDT({
        businessGroupId: bgForChain || 0,
        organizationUnitId: selectedOU || 0
      });
      const duOptions = duList.map((du) => ({
        fieldName: "DeliveryUnit",
        id: du.key,
        name: du.text,
      }));
      updateDropdownOptions("DeliveryUnit", duOptions);
    }
  };

  const handleDeliveryUnitChange = async (selectedDU, businessGroupID, organizationUnitID) => {
    console.log('Delivery Unit changed to:', selectedDU);
    const bgForChain = businessGroupID || formDataState["BusinessUnitID"] || '';
    const ouForChain = organizationUnitID || formDataState["OrganizationUnit"] || '';

    // Clear dependent field values
    setFormDataState((prev) => ({
      ...prev,
      DeliveryTeam: ''
    }));

    // Clear dependent dropdowns
    updateDropdownOptions("DeliveryTeam", []);

    // Use cached tree if available to avoid flicker; otherwise fetch
    if (bgTree && bgTree.length && bgForChain && ouForChain) {
      const bgNode = bgTree.find((b) => String(b.businessGroupID) === String(bgForChain));
      const ouNodes = bgNode?.listOrganizationUnitEntity || [];
      const ouNode = ouNodes.find((o) => String(o.locationID) === String(ouForChain));
      const duNodes = ouNode?.listDeliveryUnitEntity || [];
      const duNode = duNodes.find((u) => String(u.resourcePoolID) === String(selectedDU));
      const dtNodes = duNode?.listDeliveryTeamEntity || [];
      const dt = dtNodes.map((dt) => ({
        fieldName: "DeliveryTeam",
        id: String(dt.groupID),
        name: String(dt.groupName),
      }));

      updateDropdownOptions("DeliveryTeam", dt);
    } else {
      const { dt: dtList = [] } = await fetchBGOUDUDT({
        businessGroupId: bgForChain || 0,
        organizationUnitId: ouForChain || 0,
        deliveryUnitId: selectedDU || 0,
      });
      const dtOptions = dtList.map((dt) => ({
        fieldName: "DeliveryTeam",
        id: dt.key,
        name: dt.text,
      }));
      updateDropdownOptions("DeliveryTeam", dtOptions);
    }
  };

  // Initialize BusinessUnit dropdown
  useEffect(() => {
    if (!initiativeDetail || businessUnitData.length === 0) return;

    setInitiativeDetail((prevData) => {
      if (!prevData?.data?.listInitiativeDetailEntity) return prevData;

      let isChanged = false;

      const updatedList = prevData.data.listInitiativeDetailEntity.map(
        (item) => {
          if (item.actualFieldName === "BusinessUnitID") {
            const newDropDownData = businessUnitData.map((unit) => ({
              id: unit?.businessGroupID.toString(),
              name: `${unit?.businessGroup}`,
              fieldName: "BusinessUnitID",
            }));

            const oldString = JSON.stringify(
              item.initiativeDetailDropDownEntity || []
            );
            const newString = JSON.stringify(newDropDownData);

            if (oldString !== newString) {
              isChanged = true;
              return {
                ...item,
                initiativeDetailDropDownEntity: newDropDownData,
              };
            }
          }
          return item;
        }
      );

      if (!isChanged) return prevData;

      return {
        ...prevData,
        data: {
          ...prevData.data,
          listInitiativeDetailEntity: updatedList,
        },
      };
    });
  }, [businessUnitData, initiativeDetail]);

  const getFieldValue = (field) => {
    return (
      formDataState[field.actualFieldName] ||
      formDataState[field.fieldName] ||
      ""
    );
  };

  const openModal = (action) => {
    setModalTitle(action); // Set the modal title as the action (Submit, Approve, Reject)
    setIsModalOpen(true);
  };
  const openModal1 = (action) => {
    setModalTitle(action); // Set the modal title as the action (Submit, Approve, Reject)
    setIsModalOpen(true);
    // handleSubmitAction1();
  };
  const handleOpenDetailsModal = () => {
    setOpenDetailsModal(true);
  };

  const handleClose = () => {
    setOpenDetailsModal(false);
  };
  // Added By Madhuri.K On 08-07-2025
  const handleOpenDelegatedToModal = () => {
    setDelegatedToModal(true);
  };

  const handleDelegatedClose = () => {
    setDelegatedToModal(false);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setComments("");
  };
  const monthToNumber = (month) => {
    const months = {
      Jan: "01",
      Feb: "02",
      Mar: "03",
      Apr: "04",
      May: "05",
      Jun: "06",
      Jul: "07",
      Aug: "08",
      Sep: "09",
      Oct: "10",
      Nov: "11",
      Dec: "12",
    };
    return months[month] || "00"; // Return '00' if month is not found
  };

  const getDateOrNull = (dateString) => {
    if (!dateString) return null;
    const date = new Date(dateString);
    return isNaN(date.getTime()) ? null : date.toISOString();
  };

  const parseDate = (dateString) => {
    if (!dateString) return null; // Return null if dateString is empty
    // Normalize the date string (replace multiple spaces with a single space)
    const normalizedDateString = dateString.trim().replace(/\s+/g, " ");

    // Split the date string
    const [month, day, year, time] = normalizedDateString.split(" ");

    // Ensure day is zero-padded
    const paddedDay = String(day).padStart(2, "0");

    // Convert AM/PM time to 24-hour format
    const [hour, minute] = time.slice(0, -2).split(":");
    const period = time.slice(-2); // Get AM/PM

    let adjustedHour = parseInt(hour, 10);
    if (period === "PM" && adjustedHour < 12) {
      adjustedHour += 12; // Convert PM hour to 24-hour format
    }
    if (period === "AM" && adjustedHour === 12) {
      adjustedHour = 0; // Convert midnight hour to 0
    }

    // Create a formatted date string
    const formattedDateString = `${year}-${monthToNumber(
      month
    )}-${paddedDay}T${String(adjustedHour).padStart(2, "0")}:${minute}:00`;

    // Create a new Date object
    const parsedDate = new Date(formattedDateString);

    // Check if the date is valid
    return isNaN(parsedDate) ? null : parsedDate; // Return null if the date is invalid
  };

  // Function to validate mandatory fields
  const validateMandatoryFields = () => {
    const mandatoryFields =
      initiativeDetail?.data?.listInitiativeDetailEntity.filter(
        (field) => field.mandatory === 1 && field.isEditable === 1
      );

    for (const field of mandatoryFields) {
      if (!formDataState[field.actualFieldName]) {
        toast.error(`${field.label} should not be left blank`);
        return false; // Stop further validation after the first error
      }
    }

    return true;
  };
  // Added By Madhuri.K On 01-04-2025
  const validateDateFields = () => {
    const mandatoryFields =
      initiativeDetail?.data?.listInitiativeDetailEntity.filter((field) =>
        [
          "ExpectedStartDate",
          "ExpectedEndDate",
          "PlannedExecutionStartDate",
          "PlannedExecutionEndDate",
          "ConceptualizationStartDate",
          "ConceptualizationEndDate",
          "PlannedAcceptanceStartDate",
          "PlannedAcceptanceEndDate",
          "PlannedHandoverStartDate",
          "PlannedHandoverEndDate",
          "PlannedSolutioningStartdate",
          "PlannedSolutioningEndDate",
        ].includes(field.actualFieldName)
      );

    let dateFields = {};

    // Validate missing fields
    for (const field of mandatoryFields) {
      const fieldValue = formDataState[field.actualFieldName];
      const parsedDate = fieldValue
        ? moment
          .utc(fieldValue, ["YYYY-MM-DDTHH:mm:ss.SSSZ", "MMM DD YYYY h:mmA"])
          .isValid()
          ? moment
            .utc(fieldValue, [
              "YYYY-MM-DDTHH:mm:ss.SSSZ",
              "MMM DD YYYY h:mmA",
            ])
            .toDate()
          : null
        : null;
      // First Change
      // dateFields[field.actualFieldName] = {
      //   value: new Date(parsedDate),
      //   field,
      // };
      dateFields[field.actualFieldName] = {
        value: parsedDate ? new Date(parsedDate) : null, // Ensure null is assigned if date is invalid
        field,
      };
    }

    // Compare start and end dates
    const datePairs = [
      ["ExpectedStartDate", "ExpectedEndDate"],
      ["PlannedExecutionStartDate", "PlannedExecutionEndDate"],
      ["ConceptualizationStartDate", "ConceptualizationEndDate"],
      ["PlannedAcceptanceStartDate", "PlannedAcceptanceEndDate"],
      ["PlannedHandoverStartDate", "PlannedHandoverEndDate"],
      ["PlannedSolutioningStartdate", "PlannedSolutioningEndDate"],
    ];

    for (const [startField, endField] of datePairs) {
      const start = dateFields[startField]?.value;
      const end = dateFields[endField]?.value;

      // Compare only the date parts (ignore time)
      if (start && end) {
        const startDateOnly = moment(start).format("YYYY-MM-DD");
        const endDateOnly = moment(end).format("YYYY-MM-DD");

        if (startDateOnly > endDateOnly) {
          toast.error(
            `${dateFields[startField].field.label} should not be greater than ${dateFields[endField].field.label}`
          );
          return false;
        }
      }
    }

    return true;
  };
  // Added By Madhuri.K on 05-04-2025
  const validateNumericFields = () => {
    const numericFields = [
      "ResourceEffort",
      "CustomFieldNumeric1",
      "CustomFieldNumeric2",
      "CustomFieldNumeric3",
      "CustomFieldNumeric4",
      "CustomFieldNumeric5",
    ];

    const visibleNumericFields =
      initiativeDetail?.data?.listInitiativeDetailEntity
        .filter(
          (field) =>
            field.applicable === 1 &&
            numericFields.includes(field.actualFieldName) &&
            field.controlType !== "Combo Box"
        )
        .map((field) => field.actualFieldName);

    for (const fieldName of visibleNumericFields) {
      const fieldConfig =
        initiativeDetail?.data?.listInitiativeDetailEntity.find(
          (field) => field.actualFieldName === fieldName
        );
      const fieldValue = formDataState[fieldName];

      if (
        fieldConfig.mandatory === 1 &&
        (!fieldValue || fieldValue.trim() === "")
      ) {
        toast.error(`'${fieldConfig.label}' should not be left blank.`);
        return false;
      }

      if (
        fieldValue &&
        (isNaN(fieldValue) || fieldValue.trim().match(/[^\d.-]/))
      ) {
        toast.error(
          `Please enter only positive numeric values for '${fieldConfig.label}'.`
        );
        return false;
      }

      if (fieldValue && Number(fieldValue) < 0) {
        toast.error(
          `Please enter only positive numeric values for '${fieldConfig.label}'.`
        );
        return false;
      }
    }

    return true; // Passed all checks
  };

  const handleSave = async () => {
    const missingFields = [];

    if (!validateMandatoryFields()) {
      return; // Stop execution if mandatory fields are missing
    }

    if (!validateDateFields()) {
      return; // Stop execution if mandatory fields are missing
    }
    if (!validateNumericFields()) {
      return; // Stop execution if mandatory fields are missing
    }

    // Check if the title already exists
    const existingTitle =
      initiativeDetail?.data?.listInitiativeDetailEntity.find(
        (item) =>
          item.fieldName === "Title" &&
          item.controlValue === formDataState["Initiative Title"]
      );

    if (existingTitle) {
      toast.error("Initiative Title already exists");
      return; // Stop further execution
    }

    const formDataToSave = {
      projectManager: Number(formDataState["ProjectManager"]),
      ideaID: initiativesID,
      title: formDataState["Initiative Title"],
      title: getFieldValue({
        actualFieldName: "Title",
        fieldName: "Initiative Title",
      }),
      // Changed By Madhuri.K On 22-04-2025
      organizationUnit: formDataState["OrganizationUnit"]
        ? parseInt(formDataState["OrganizationUnit"])
        : 0,
      deliveryUnit: formDataState["Delivery Unit"]
        ? parseInt(formDataState["Delivery Unit"])
        : 0,
      description: getFieldValue({
        actualFieldName: "Description",
        fieldName: "Initiative Description",
      }),
      businessUnitID: getFieldValue({
        actualFieldName: "BusinessUnitID",
        fieldName: "Business Unit",
      }),
      //Commented by Parth.G to get actual formData
      // organizationUnit: getFieldValue({
      //   actualFieldName: "OrganizationUnit",
      //   fieldName: "OrganizationUnit",
      // }),
      deliveryUnit: getFieldValue({
        actualFieldName: "DeliveryUnit",
        fieldName: "DeliveryUnit",
      }),
      conceptualizationComment: getFieldValue({
        actualFieldName: "ConceptualizationComment",
        fieldName: "ConceptualizationComment",
      }),
      requestTypeID: getFieldValue({
        actualFieldName: "RequestTypeID",
        fieldName: "Initiative Type",
      }),

      resourceapproachid: getFieldValue({
        actualFieldName: "ResourceApproachID",
        fieldName: "Resource Approach",
      }),
      vendorid: getFieldValue({
        actualFieldName: "VendorID",
        fieldName: "Vendor",
      }),
      priorityID: getFieldValue({
        actualFieldName: "PriorityID",
        fieldName: "Priority",
      }),
      //   Second Change
      PracticeID: getFieldValue({
        actualFieldName: "PracticeID",
        fieldName: "Practice",
      }),
      resourceEffort: getFieldValue({
        actualFieldName: "ResourceEffort",
        fieldName: "Resource Effort",
      }),

      bgRepresentatives: getFieldValue({
        actualFieldName: "BGRepresentatives",
        fieldName: "BGRepresentatives",
      }),

      // expectedStartDate: formDataState["ExpectedStartDate"] || null,

      expectedStartDate: formDataState["ExpectedStartDate"]
        ? moment
          .utc(
            formDataState["ExpectedStartDate"],
            ["YYYY-MM-DDTHH:mm:ss.SSSZ", "MMM DD YYYY h:mmA"] // Handle both formats
          )
          .isValid()
          ? moment
            .utc(
              formDataState["ExpectedStartDate"],
              ["YYYY-MM-DDTHH:mm:ss.SSSZ", "MMM DD YYYY h:mmA"] // Use same formats
            )
            .toDate()
          : null
        : null,

      // expectedStartDate: formDataState["ExpectedStartDate"]
      //   ? moment(formDataState["ExpectedStartDate"], [
      //     "YYYY-MM-DDTHH:mm:ss.SSSZ",
      //     "MMM DD YYYY h:mmA",
      //   ])
      //     .startOf("day")
      //     .utc()
      //     .toDate()
      //   : null,

      // expectedEndDate: formDataState["ExpectedEndDate"]
      //   ? moment(formDataState["ExpectedEndDate"], [
      //     "YYYY-MM-DDTHH:mm:ss.SSSZ",
      //     "MMM DD YYYY h:mmA",
      //   ])
      //     .startOf("day")
      //     .utc()
      //     .toDate()
      //   : null,

      expectedEndDate: formDataState["ExpectedEndDate"]
        ? moment
          .utc(
            formDataState["ExpectedEndDate"],
            ["YYYY-MM-DDTHH:mm:ss.SSSZ", "MMM DD YYYY h:mmA"] // Handle both formats
          )
          .isValid()
          ? moment
            .utc(
              formDataState["ExpectedEndDate"],
              ["YYYY-MM-DDTHH:mm:ss.SSSZ", "MMM DD YYYY h:mmA"] // Use same formats
            )
            .toDate()
          : null
        : null,

      // customFieldDate1: formDataState["CustomFieldDate1"]
      //   ? moment(formDataState["CustomFieldDate1"], [
      //     "YYYY-MM-DDTHH:mm:ss.SSSZ",
      //     "MMM DD YYYY h:mmA",
      //   ])
      //     .startOf("day")
      //     .utc()
      //     .toDate()
      //   : null,

      customFieldDate1: formDataState["CustomFieldDate1"]
        ? moment
          .utc(
            formDataState["CustomFieldDate1"],
            ["YYYY-MM-DDTHH:mm:ss.SSSZ", "MMM DD YYYY h:mmA"] // Handle both formats
          )
          .isValid()
          ? moment
            .utc(
              formDataState["CustomFieldDate1"],
              ["YYYY-MM-DDTHH:mm:ss.SSSZ", "MMM DD YYYY h:mmA"] // Use same formats
            )
            .toDate()
          : null
        : null,

      deliveryUnit: formDataState["DeliveryUnit"]
        ? parseInt(formDataState["DeliveryUnit"])
        : 0,
      deliveryTeam: formDataState["DeliveryTeam"]
        ? parseInt(formDataState["DeliveryTeam"])
        : 0,
      // Label for Sponsor
      bgRepresentatives: formDataState["BGRepresentatives"],
      // Label Overall Initiative Effort (PD)
      resourceEffort: formDataState["ResourceEffort"]
        ? parseFloat(formDataState["ResourceEffort"])
        : 0,
      priorityID: formDataState["PriorityID"]
        ? parseInt(formDataState["PriorityID"])
        : 0,
      requestTypeID: formDataState["RequestTypeID"]
        ? parseInt(formDataState["RequestTypeID"])
        : 0,
      PracticeID: formDataState["PracticeID"]
        ? parseInt(formDataState["PracticeID"])
        : 0,
      //  resourceapproachid: formDataState["ResourceApproachID"],
      // Changed By Madhuri.K On 22-04-2025
      resourceapproachid: formDataState["ResourceApproachID"]
        ? parseInt(formDataState["ResourceApproachID"])
        : 0,
      frequency: formDataState["Frequency"],
      productLineId: formDataState["Product Line ID"]
        ? parseInt(formDataState["Product Line ID"])
        : 0,
      productID: formDataState["Product ID"]
        ? parseInt(formDataState["Product ID"])
        : 0,

      vendorid: formDataState["VendorID"]
        ? parseInt(formDataState["VendorID"])
        : 0,
      reason: formDataState["Reason"] ? formDataState["Reason"] : "",
      // initiationDate: formDataState["InitiationDate"]
      //   ? moment(formDataState["InitiationDate"], [
      //     "YYYY-MM-DDTHH:mm:ss.SSSZ",
      //     "MMM DD YYYY h:mmA",
      //   ])
      //     .startOf("day")
      //     .utc()
      //     .toDate()
      //   : null,

      initiationDate: formDataState["InitiationDate"]
        ? moment
          .utc(
            formDataState["InitiationDate"],
            ["YYYY-MM-DDTHH:mm:ss.SSSZ", "MMM DD YYYY h:mmA"] // Handle both formats
          )
          .isValid()
          ? moment
            .utc(
              formDataState["InitiationDate"],
              ["YYYY-MM-DDTHH:mm:ss.SSSZ", "MMM DD YYYY h:mmA"] // Use same formats
            )
            .toDate()
          : null
        : null,

      originalRequester: formDataState["OriginalRequester"]
        ? parseInt(formDataState["OriginalRequester"])
        : 0,
      objectives: formDataState["Objectives"],

      // conceptualizationStartDate: formDataState["ConceptualizationStartDate"]
      //   ? moment(formDataState["ConceptualizationStartDate"], [
      //     "YYYY-MM-DDTHH:mm:ss.SSSZ",
      //     "MMM DD YYYY h:mmA",
      //   ])
      //     .startOf("day")
      //     .utc()
      //     .toDate()
      //   : null,
      conceptualizationStartDate: formDataState["ConceptualizationStartDate"]
        ? moment
          .utc(
            formDataState["ConceptualizationStartDate"],
            ["YYYY-MM-DDTHH:mm:ss.SSSZ", "MMM DD YYYY h:mmA"] // Handle both formats
          )
          .isValid()
          ? moment
            .utc(
              formDataState["ConceptualizationStartDate"],
              ["YYYY-MM-DDTHH:mm:ss.SSSZ", "MMM DD YYYY h:mmA"] // Use same formats
            )
            .toDate()
          : null
        : null,
      // conceptualizationEndDate: formDataState["ConceptualizationEndDate"]
      //   ? moment(formDataState["ConceptualizationEndDate"], [
      //     "YYYY-MM-DDTHH:mm:ss.SSSZ",
      //     "MMM DD YYYY h:mmA",
      //   ])
      //     .startOf("day")
      //     .utc()
      //     .toDate()
      //   : null,

      conceptualizationEndDate: formDataState["ConceptualizationEndDate"]
        ? moment
          .utc(
            formDataState["ConceptualizationEndDate"],
            ["YYYY-MM-DDTHH:mm:ss.SSSZ", "MMM DD YYYY h:mmA"] // Handle both formats
          )
          .isValid()
          ? moment
            .utc(
              formDataState["ConceptualizationEndDate"],
              ["YYYY-MM-DDTHH:mm:ss.SSSZ", "MMM DD YYYY h:mmA"] // Use same formats
            )
            .toDate()
          : null
        : null,

      conceptualizationComment: formDataState["ConceptualizationComment"],

      // plannedSolutioningStartdate: formDataState["PlannedSolutioningStartdate"]
      //   ? moment(formDataState["PlannedSolutioningStartdate"], [
      //     "YYYY-MM-DDTHH:mm:ss.SSSZ",
      //     "MMM DD YYYY h:mmA",
      //   ])
      //     .startOf("day")
      //     .utc()
      //     .toDate()
      //   : null,

      plannedSolutioningStartdate: formDataState["PlannedSolutioningStartdate"]
        ? moment
          .utc(
            formDataState["PlannedSolutioningStartdate"],
            ["YYYY-MM-DDTHH:mm:ss.SSSZ", "MMM DD YYYY h:mmA"] // Handle both formats
          )
          .isValid()
          ? moment
            .utc(
              formDataState["PlannedSolutioningStartdate"],
              ["YYYY-MM-DDTHH:mm:ss.SSSZ", "MMM DD YYYY h:mmA"] // Use same formats
            )
            .toDate()
          : null
        : null,

      // plannedSolutioningEndDate: formDataState["PlannedSolutioningEndDate"]
      //   ? moment(formDataState["PlannedSolutioningEndDate"], [
      //     "YYYY-MM-DDTHH:mm:ss.SSSZ",
      //     "MMM DD YYYY h:mmA",
      //   ])
      //     .startOf("day")
      //     .utc()
      //     .toDate()
      //   : null,

      plannedSolutioningEndDate: formDataState["PlannedSolutioningEndDate"]
        ? moment
          .utc(
            formDataState["PlannedSolutioningEndDate"],
            ["YYYY-MM-DDTHH:mm:ss.SSSZ", "MMM DD YYYY h:mmA"] // Handle both formats
          )
          .isValid()
          ? moment
            .utc(
              formDataState["PlannedSolutioningEndDate"],
              ["YYYY-MM-DDTHH:mm:ss.SSSZ", "MMM DD YYYY h:mmA"] // Use same formats
            )
            .toDate()
          : null
        : null,

      solutioningComment: formDataState["SolutioningComment"],

      // plannedExecutionStartDate: formDataState["PlannedExecutionStartDate"]
      //   ? moment(formDataState["PlannedExecutionStartDate"], [
      //     "YYYY-MM-DDTHH:mm:ss.SSSZ",
      //     "MMM DD YYYY h:mmA",
      //   ])
      //     .startOf("day")
      //     .utc()
      //     .toDate()
      //   : null,

      plannedExecutionStartDate: formDataState["PlannedExecutionStartDate"]
        ? moment
          .utc(
            formDataState["PlannedExecutionStartDate"],
            ["YYYY-MM-DDTHH:mm:ss.SSSZ", "MMM DD YYYY h:mmA"] // Handle both formats
          )
          .isValid()
          ? moment
            .utc(
              formDataState["PlannedExecutionStartDate"],
              ["YYYY-MM-DDTHH:mm:ss.SSSZ", "MMM DD YYYY h:mmA"] // Use same formats
            )
            .toDate()
          : null
        : null,

      // plannedExecutionEndDate: formDataState["PlannedExecutionEndDate"]
      //   ? moment(formDataState["PlannedExecutionEndDate"], [
      //     "YYYY-MM-DDTHH:mm:ss.SSSZ",
      //     "MMM DD YYYY h:mmA",
      //   ])
      //     .startOf("day")
      //     .utc()
      //     .toDate()
      //   : null,

      plannedExecutionEndDate: formDataState["PlannedExecutionEndDate"]
        ? moment
          .utc(
            formDataState["PlannedExecutionEndDate"],
            ["YYYY-MM-DDTHH:mm:ss.SSSZ", "MMM DD YYYY h:mmA"] // Handle both formats
          )
          .isValid()
          ? moment
            .utc(
              formDataState["PlannedExecutionEndDate"],
              ["YYYY-MM-DDTHH:mm:ss.SSSZ", "MMM DD YYYY h:mmA"] // Use same formats
            )
            .toDate()
          : null
        : null,
      executionComment: formDataState["ExecutionComment"],
      // plannedAcceptanceStartDate: formDataState["PlannedAcceptanceStartDate"]
      //   ? moment(formDataState["PlannedAcceptanceStartDate"], [
      //     "YYYY-MM-DDTHH:mm:ss.SSSZ",
      //     "MMM DD YYYY h:mmA",
      //   ])
      //     .startOf("day")
      //     .utc()
      //     .toDate()
      //   : null,

      plannedAcceptanceStartDate: formDataState["PlannedAcceptanceStartDate"]
        ? moment
          .utc(
            formDataState["PlannedAcceptanceStartDate"],
            ["YYYY-MM-DDTHH:mm:ss.SSSZ", "MMM DD YYYY h:mmA"] // Handle both formats
          )
          .isValid()
          ? moment
            .utc(
              formDataState["PlannedAcceptanceStartDate"],
              ["YYYY-MM-DDTHH:mm:ss.SSSZ", "MMM DD YYYY h:mmA"] // Use same formats
            )
            .toDate()
          : null
        : null,

      plannedAcceptanceEndDate: formDataState["PlannedAcceptanceEndDate"]
        ? moment
          .utc(
            formDataState["PlannedAcceptanceEndDate"],
            ["YYYY-MM-DDTHH:mm:ss.SSSZ", "MMM DD YYYY h:mmA"] // Handle both formats
          )
          .isValid()
          ? moment
            .utc(
              formDataState["PlannedAcceptanceEndDate"],
              ["YYYY-MM-DDTHH:mm:ss.SSSZ", "MMM DD YYYY h:mmA"] // Use same formats
            )
            .toDate()
          : null
        : null,

      // plannedAcceptanceEndDate: formDataState["PlannedAcceptanceEndDate"]
      //   ? moment(formDataState["PlannedAcceptanceEndDate"], [
      //     "YYYY-MM-DDTHH:mm:ss.SSSZ",
      //     "MMM DD YYYY h:mmA",
      //   ])
      //     .startOf("day")
      //     .utc()
      //     .toDate()
      //   : null,
      acceptanceComment: formDataState["AcceptanceComment"],
      // plannedHandoverStartDate: formDataState["PlannedHandoverStartDate"]
      //   ? moment(formDataState["PlannedHandoverStartDate"], [
      //     "YYYY-MM-DDTHH:mm:ss.SSSZ",
      //     "MMM DD YYYY h:mmA",
      //   ])
      //     .startOf("day")
      //     .utc()
      //     .toDate()
      //   : null,

      plannedHandoverStartDate: formDataState["PlannedHandoverStartDate"]
        ? moment
          .utc(
            formDataState["PlannedHandoverStartDate"],
            ["YYYY-MM-DDTHH:mm:ss.SSSZ", "MMM DD YYYY h:mmA"] // Handle both formats
          )
          .isValid()
          ? moment
            .utc(
              formDataState["PlannedExecutionStartDate"],
              ["YYYY-MM-DDTHH:mm:ss.SSSZ", "MMM DD YYYY h:mmA"] // Use same formats
            )
            .toDate()
          : null
        : null,

      // plannedHandoverEndDate: formDataState["PlannedHandoverEndDate"]
      //   ? moment(formDataState["PlannedHandoverEndDate"], [
      //     "YYYY-MM-DDTHH:mm:ss.SSSZ",
      //     "MMM DD YYYY h:mmA",
      //   ])
      //     .startOf("day")
      //     .utc()
      //     .toDate()
      //   : null,

      plannedHandoverEndDate: formDataState["PlannedHandoverEndDate"]
        ? moment
          .utc(
            formDataState["PlannedHandoverEndDate"],
            ["YYYY-MM-DDTHH:mm:ss.SSSZ", "MMM DD YYYY h:mmA"] // Handle both formats
          )
          .isValid()
          ? moment
            .utc(
              formDataState["PlannedHandoverEndDate"],
              ["YYYY-MM-DDTHH:mm:ss.SSSZ", "MMM DD YYYY h:mmA"] // Use same formats
            )
            .toDate()
          : null
        : null,

      handoverComment: formDataState["HandoverComment"],
      systemAffected: formDataState["SystemAffected"],
      customFieldText1: formDataState["CustomFieldText1"],
      customFieldText2: formDataState["CustomFieldText2"],
      customFieldText3: formDataState["CustomFieldText3"],
      customFieldText4: formDataState["CustomFieldText4"],
      customFieldText5: formDataState["CustomFieldText5"],
      // Added By Madhuri.K On 16-04-2025
      customTextArea1: formDataState["CustomTextArea1"],
      customTextArea2: formDataState["CustomTextArea2"],
      customTextArea3: formDataState["CustomTextArea3"],
      // customFieldDate1: formDataState["CustomFieldDate1"]
      //   ? moment(formDataState["CustomFieldDate1"], [
      //     "YYYY-MM-DDTHH:mm:ss.SSSZ",
      //     "MMM DD YYYY h:mmA",
      //   ])
      //     .startOf("day")
      //     .utc()
      //     .toDate()
      //   : null,
      customFieldDate1: formDataState["CustomFieldDate1"]
        ? moment
          .utc(
            formDataState["CustomFieldDate1"],
            ["YYYY-MM-DDTHH:mm:ss.SSSZ", "MMM DD YYYY h:mmA"] // Handle both formats
          )
          .isValid()
          ? moment
            .utc(
              formDataState["CustomFieldDate1"],
              ["YYYY-MM-DDTHH:mm:ss.SSSZ", "MMM DD YYYY h:mmA"] // Use same formats
            )
            .toDate()
          : null
        : null,
      // customFieldDate2: formDataState["CustomFieldDate2"]
      //   ? moment(formDataState["CustomFieldDate2"], [
      //     "YYYY-MM-DDTHH:mm:ss.SSSZ",
      //     "MMM DD YYYY h:mmA",
      //   ])
      //     .startOf("day")
      //     .utc()
      //     .toDate()
      //   : null,
      customFieldDate2: formDataState["CustomFieldDate2"]
        ? moment
          .utc(
            formDataState["CustomFieldDate2"],
            ["YYYY-MM-DDTHH:mm:ss.SSSZ", "MMM DD YYYY h:mmA"] // Handle both formats
          )
          .isValid()
          ? moment
            .utc(
              formDataState["CustomFieldDate2"],
              ["YYYY-MM-DDTHH:mm:ss.SSSZ", "MMM DD YYYY h:mmA"] // Use same formats
            )
            .toDate()
          : null
        : null,
      // customFieldDate3: formDataState["CustomFieldDate3"]
      //   ? moment(formDataState["CustomFieldDate3"], [
      //     "YYYY-MM-DDTHH:mm:ss.SSSZ",
      //     "MMM DD YYYY h:mmA",
      //   ])
      //     .startOf("day")
      //     .utc()
      //     .toDate()
      //   : null,
      customFieldDate3: formDataState["CustomFieldDate3"]
        ? moment
          .utc(
            formDataState["CustomFieldDate3"],
            ["YYYY-MM-DDTHH:mm:ss.SSSZ", "MMM DD YYYY h:mmA"] // Handle both formats
          )
          .isValid()
          ? moment
            .utc(
              formDataState["CustomFieldDate3"],
              ["YYYY-MM-DDTHH:mm:ss.SSSZ", "MMM DD YYYY h:mmA"] // Use same formats
            )
            .toDate()
          : null
        : null,
      customFieldNumeric1: formDataState["CustomFieldNumeric1"]
        ? parseFloat(formDataState["CustomFieldNumeric1"])
        : 0,
      customFieldNumeric2: formDataState["CustomFieldNumeric2"]
        ? parseFloat(formDataState["CustomFieldNumeric2"])
        : 0,
      customFieldNumeric3: formDataState["CustomFieldNumeric3"]
        ? parseFloat(formDataState["CustomFieldNumeric3"])
        : 0,
      customFieldNumeric4: formDataState["CustomFieldNumeric4"]
        ? parseFloat(formDataState["CustomFieldNumeric4"])
        : 0,
      customFieldNumeric5: formDataState["CustomFieldNumeric5"]
        ? parseFloat(formDataState["CustomFieldNumeric5"])
        : 0,
      // customFieldDate4: formDataState["CustomFieldDate4"]
      //   ? moment(formDataState["CustomFieldDate4"], [
      //     "YYYY-MM-DDTHH:mm:ss.SSSZ",
      //     "MMM DD YYYY h:mmA",
      //   ])
      //     .startOf("day")
      //     .utc()
      //     .toDate()
      //   : null,
      customFieldDate4: formDataState["CustomFieldDate4"]
        ? moment
          .utc(
            formDataState["CustomFieldDate4"],
            ["YYYY-MM-DDTHH:mm:ss.SSSZ", "MMM DD YYYY h:mmA"] // Handle both formats
          )
          .isValid()
          ? moment
            .utc(
              formDataState["CustomFieldDate4"],
              ["YYYY-MM-DDTHH:mm:ss.SSSZ", "MMM DD YYYY h:mmA"] // Use same formats
            )
            .toDate()
          : null
        : null,
      // customFieldDate5: formDataState["CustomFieldDate5"]
      //   ? moment(formDataState["CustomFieldDate5"], [
      //     "YYYY-MM-DDTHH:mm:ss.SSSZ",
      //     "MMM DD YYYY h:mmA",
      //   ])
      //     .startOf("day")
      //     .utc()
      //     .toDate()
      //   : null,
      customFieldDate5: formDataState["CustomFieldDate5"]
        ? moment
          .utc(
            formDataState["CustomFieldDate5"],
            ["YYYY-MM-DDTHH:mm:ss.SSSZ", "MMM DD YYYY h:mmA"] // Handle both formats
          )
          .isValid()
          ? moment
            .utc(
              formDataState["CustomFieldDate5"],
              ["YYYY-MM-DDTHH:mm:ss.SSSZ", "MMM DD YYYY h:mmA"] // Use same formats
            )
            .toDate()
          : null
        : null,
      modifiedBy: employeeId,
      modifiedDate: new Date().toISOString(),
    };

    const accessToken = sessionStorage.getItem("access_token");
    const url = `/api/InitiativeAddNew/UpdInitiativeDetails`;

    try {
      // const response = await axios.put(url, formDataToSave, {
      //   headers: {
      //     Authorization: `Bearer ${accessToken}`,
      //     "Content-Type": "application/json"
      //   }
      // });
      const response = await AxiosInstance1.put(url, formDataToSave, {
        headers: {
          // Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      });

      if (response.status === 200) {
        const result = response.data;

        if (result.data?.length > 0 && result.data[0].result === "Success") {
          // toast.success("Initiative details updated successfully !");
          if (modalTitle !== "Submit" && modalTitle !== "Approve") {
            toast.success("Initiative details updated successfully !");
          }
        } else {
          toast.error(result.data?.[0]?.result || "Unexpected error occurred.");
        }

        // if (
        //   result.data &&
        //   result.data.length > 0 &&
        //   result.data[0].result === "Success"
        // ) {
        //   toast.success("Data saved successfully!");
        // } else {
        //   toast.error(`${result.data?.[0]?.result || "Unexpected error"}`);
        // }

        // toast.success("Data saved successfully!");

        // Fetch updated initiative details again
        setRefresh1(!refresh);
      } else {
        toast.error("Failed to save data. Please try again.");
      }
    } catch (error) {
      console.error("Save error:", error);
      toast.error("An error occurred while saving data.");
    }
  };

  const MAX_IMAGE_SIZE = 10 * 1024; // 10 KB in bytes
  const renderFormElements = () => {
    const handleImageUpload = async (event) => {
      const file = event.target.files[0];
      event.target.value = null; // ✅ allow same file to be selected again

      const allowedTypes = ["image/jpeg", "image/png"];
      const MAX_IMAGE_SIZE = 10 * 1024; // 10 KB

      if (!file) {
        toast.error("No file selected. Please choose an image.");
        return;
      }

      if (!allowedTypes.includes(file.type)) {
        toast.error("Only JPG and PNG files are allowed.");
        return;
      }

      if (file.size > MAX_IMAGE_SIZE) {
        toast.error("File size exceeds 10 KB.");
        return;
      }

      const formData = new FormData();
      formData.append("formFile", file, file.name);

      const iniID = initiativesID; // Replace with dynamic IniID
      // const url = `${window.runtimeConfig.REACT_APP_BASEURL_ACCESS_CONTROL1}/api/FileUpDown/IniIconUpload?IniID=${iniID}&EmpID=${employeeId}`;
      const url = `/api/FileUpDown/IniIconUpload?IniID=${iniID}&EmpID=${employeeId}&t=${new Date().getTime()}`;
      const accessToken = sessionStorage.getItem("access_token");

      try {
        const response = await AxiosInstance1.put(url, formData, {
          headers: {
            // Authorization: `Bearer ${accessToken}`,
            "Content-Type": "multipart/form-data",
          },
        });

        // const reader = new FileReader();
        // reader.onloadend = () => {
        //   const base64Image = reader.result;
        //   setFormDataState({
        //     ...formDataState,
        //     profileImage: base64Image,
        //   });
        // };
        // reader.readAsDataURL(file);

        // setRefresh12(!refresh12);
        setRefresh12((prev) => !prev);
        setTimeout(() => {
          setRefresh1(!refresh);
        }, 2000);

        toast.success("Image uploaded successfully!");
      } catch (error) {
        console.error("Image upload error:", error);
        toast.error("Failed to upload image. Please try again.");
      }
    };

    if (initiativeDetail) {
      const fields = Array.isArray(
        initiativeDetail?.data?.listInitiativeDetailEntity
      )
        ? [...initiativeDetail?.data?.listInitiativeDetailEntity]
        : [];

      const applicableFields = fields.filter((field) => field.applicable === 1);
      const groupedFields = applicableFields.reduce((acc, field) => {
        if (!acc[field.pageRoWNo]) {
          acc[field.pageRoWNo] = [];
        }
        acc[field.pageRoWNo].push(field);
        return acc;
      }, {});

      Object.keys(groupedFields).forEach((rowNo) => {
        groupedFields[rowNo].sort((a, b) => a.pageOrderNo - b.pageOrderNo);
      });

      const sortedRows = Object.keys(groupedFields).sort((a, b) => a - b);
      const isValidDate = (dateString) => {
        const date = new Date(dateString);
        return date instanceof Date && !isNaN(date);
      };

      return (
        <>
          {/* Render the rest of the form */}
          {sortedRows.map((rowNo) => (
            <div className="row" key={rowNo}>
              {groupedFields[rowNo].map((field, index) => {
                if (field.id == -1) {
                  pimage = field.controlValue;
                }

                const isRequired = field.mandatory === 1; // This should only return true if mandatory is 1
                const isEditable = field.isEditable === 1;
                const options = field.initiativeDetailDropDownEntity.map(
                  (item) => ({
                    key: item.id,
                    text: item.name,
                  })
                );

                // Render the image and TextField on the same line for pageRoWNo: 1 and pageOrderNo: 1
                if (field.pageRoWNo === 1 && field.pageOrderNo === 1) {
                  return (
                    <div
                      key={index}
                      className="col-md-12 d-flex align-items-center mt-2"
                    >
                      <div className={profilePictureContainerStyles}>
                        <Image
                          src={pimage || "https://via.placeholder.com/72"}
                          alt="Profile Picture"
                          className={profilePictureStyles}
                          imageFit={ImageFit.cover}
                          width={72}
                          height={72}
                        />
                        <Tooltip title="Upload Image">
                          <EditOutlinedIcon
                            className={editIconStyles}
                            onClick={() =>
                              document.getElementById("uploadImage").click()
                            }
                          />
                        </Tooltip>
                        <input
                          type="file"
                          id="uploadImage"
                          style={{ display: "none" }}
                          accept="image/*"
                          onChange={handleImageUpload}
                        />
                      </div>
                      <TextField
                        label={<>{field.label}</>}
                        // placeholder={field.controlValue || ""}
                        className="ml-4"
                        // value={formDataState[field.actualFieldName] || ""} // Use actualFieldName
                        //  Added By Madhuri.K On 06-Feb-2025 for value is showing as placeholder start here
                        placeholder={field.placeholder || ""} // Use a separate placeholder if needed
                        value={
                          formDataState[field.actualFieldName] !== undefined
                            ? formDataState[field.actualFieldName]
                            : field.controlValue || ""
                        } // Ensure controlValue is shown when no user input is available
                        //  Added By Madhuri.K On 06-Feb-2025 for value is showing as placeholder end here
                        onChange={(ev, newValue) => {
                          setFormDataState({
                            ...formDataState,
                            [field.actualFieldName]: newValue, // Use actualFieldName
                          });
                          handleFieldChange(newValue, field.actualFieldName); // Use actualFieldName
                        }}
                        // required={isRequired}
                        disabled={!isEditable}
                        // Commented By Madhuri.K on 09-10-2025
                        // style={{
                        //   marginLeft: "20px",
                        //   flex: 1,
                        //   "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline":
                        //     {
                        //       borderColor: "rgba(0, 0, 0, 0.23)", // Set default border color
                        //     },
                        //   "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline":
                        //     {
                        //       borderColor: "rgba(0, 0, 0, 0.5)", // Set hover border color
                        //     },
                        //   "&.Mui-focused .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline":
                        //     {
                        //       borderColor: "rgba(0, 0, 0, 0.87)", // Set focused border color
                        //     },
                        // }}
                        // InputProps={{
                        //   style: {
                        //     borderColor: "rgba(0, 0, 0, 0.23)", // Set default border color for InputProps
                        //   },
                        //   classes: {
                        //     notchedOutline: "Custom-notched-outline", // Optional: Add a custom class if needed
                        //   },
                        // }} // Adjust margin and flex properties
                        // Added By Madhuri.K on 09-10-2025
                        style={{
                          // marginLeft: "20px",
                          flex: 1,
                        }}
                        styles={{
                          root: {
                            marginLeft: "20px",
                          },
                          fieldGroup: {
                            backgroundColor: "transparent",
                            border: !isEditable ? "1px solid rgb(148, 146, 146)" : "1px solid #605e5c",
                          },
                        }} />
                    </div>
                  );
                }
                const isRequired1 = field.mandatory === 1;
                // Handle other field render logic
                switch (field.controlType) {
                  case "Text Box":
                    // Added By Madhuri.K On 09-10-2025 - 3 columns per row layout
                    return (
                      <div
                        key={index}
                        className={`col-md-4 mt-2 form-group row-${field.pageRoWNo}`}
                      >
                        <TextField styles={{ marginLeft: "20px" }}
                          // Commented By Madhuri.K on 06-Feb-2025
                          label={<>{field.label}</>}
                          // placeholder={field.controlValue || ""}
                          // value={formDataState[field.actualFieldName] || ""} // Use actualFieldName

                          //  Added By Madhuri.K On 06-Feb-2025 for value is showing as placeholder start here
                          placeholder={field.placeholder || ""} // Use a separate placeholder if needed
                          value={
                            formDataState[field.actualFieldName] !== undefined
                              ? formDataState[field.actualFieldName]
                              : field.controlValue || ""
                          } // Ensure controlValue is shown when no user input is available
                          //  Added By Madhuri.K On 06-Feb-2025 for value is showing as placeholder end here
                          onChange={(ev, newValue) => {
                            setFormDataState({
                              ...formDataState,
                              [field.actualFieldName]: newValue, // Use actualFieldName
                            });
                            handleFieldChange(newValue, field.actualFieldName); // Use actualFieldName
                          }}
                          required={field.mandatory === 1}
                          disabled={!isEditable}
                          sx={{
                            marginLeft: "20px",
                            flex: 1,
                            "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline":
                            {
                              borderColor: "rgba(0, 0, 0, 0.23)",
                            },
                            "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline":
                            {
                              borderColor: "rgba(0, 0, 0, 0.5)",
                            },
                            "&.Mui-focused .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline":
                            {
                              borderColor: "rgba(0, 0, 0, 0.87)",
                            },
                            "& .MuiInputLabel-root": {
                              color: "black !important",
                            },
                            "& .Mui-disabled .MuiInputLabel-root": {
                              color: "black !important",
                            },
                          }}
                        />
                      </div>
                    );

                  case "Combo Box":
                    // Added By Madhuri.K On 09-10-2025 - 3 columns per row layout
                    const defaultOption = {
                      key: null,
                      text: `Select ${field.label}`,
                    };

                    const dropdownOptions = [
                      defaultOption,
                      ...field.initiativeDetailDropDownEntity.map((option) => ({
                        key: `${option.id}`,
                        text: `${option.name}`,
                      })),
                    ];

                    return (
                      <div
                        key={index}
                        className={`col-md-4 mt-2 form-group row-${field.pageRoWNo}`}
                      >
                        {/* Modified by Gauri to fix dropdown position issue on 20 Nov 2025 */}
                        <Dropdown
                          label={<>{field.label}</>}
                          placeholder={`Select ${field.label}`} // Placeholder text for the dropdown
                          options={dropdownOptions}
                          selectedKey={
                            formDataState[field.actualFieldName] ?? null
                          } // Use actualFieldName
                          onChange={async (ev, item) => {
                            const value = item ? item.key : null;

                            // Update form state first
                            setFormDataState((prev) => ({
                              ...prev,
                              [field.actualFieldName]: value,
                            }));

                            handleFieldChange(
                              value ? `${value}` : null,
                              field.actualFieldName
                            );

                            // Removed By Madhuri.K On 31-10-2025 - Old complex onChange logic (200+ lines) replaced with handler functions
                            // Added By Madhuri.K On 31-10-2025 - Use handler functions for dependent dropdowns (similar to UserMaintenance)
                            if (field.actualFieldName === "BusinessUnitID") {
                              await handleBusinessGroupChange(value);
                            } else if (field.actualFieldName === "OrganizationUnit") {
                              await handleOrgUnitChange(value, formDataState["BusinessUnitID"]);
                            } else if (field.actualFieldName === "DeliveryUnit") {
                              await handleDeliveryUnitChange(
                                value,
                                formDataState["BusinessUnitID"],
                                formDataState["OrganizationUnit"]
                              );
                            }
                          }}
                          required={field.mandatory === 1}
                          disabled={!isEditable}
                          styles={{
                            label: {
                              color: !isEditable ? "black !important" : "", // Ensure label stays black even when disabled
                            },
                          }}
                          calloutProps={commonCalloutProps}
                        />
                      </div>
                    );
                  case "Date":
                    // Added By Madhuri.K On 09-10-2025 - 3 columns per row layout
                    return (
                      <div
                        key={index}
                        className={`col-md-4 mt-2 form-group row-${field.pageRoWNo}`}
                      >
                        {/* <DatePicker
                          label={<>{field.label}</>}
                          value={
                            formDataState[field.actualFieldName]
                              ? moment
                                  .utc(
                                    formDataState[field.actualFieldName],
                                    // "MMM DD YYYY h:mmA","YYYY-MM-DDTHH:mm:ss.SSSZ"
                                    [
                                      "MMM DD YYYY h:mmA",
                                      "YYYY-MM-DDTHH:mm:ss.SSSZ",
                                    ]
                                  )
                                  .isValid()
                                ? moment
                                    .utc(formDataState[field.actualFieldName], [
                                      "YYYY-MM-DDTHH:mm:ss.SSSZ",
                                      "MMM DD YYYY h:mmA",
                                    ])
                                    .toDate()
                                : null
                              : null
                          }
                          // value={
                          //   formDataState[field.actualFieldName]
                          //     ? (() => {
                          //         const dateValue =
                          //           formDataState[field.actualFieldName];
                          //         return dateValue instanceof Date &&
                          //           !isNaN(dateValue)
                          //           ? dateValue
                          //           : moment(
                          //               dateValue,
                          //               "MMM DD YYYY h:mmA"
                          //             ).isValid()
                          //           ? moment(
                          //               dateValue,
                          //               "MMM DD YYYY h:mmA"
                          //             ).toDate()
                          //           : null;
                          //       })()
                          //     : null
                          // }
                          onSelectDate={(date) => {
                            if (!date) return;

                            //  Convert selected date to UTC before saving
                            const isoDate = moment(date).utc().toISOString();

                            setFormDataState({
                              ...formDataState,
                              [field.actualFieldName]: isoDate,
                            });


                            handleFieldChange(isoDate, field.actualFieldName);
                          }}
                          placeholder="Select Date"
                          isRequired={field.mandatory === 1}
                          disabled={!field.isEditable}
                          styles={{
                            label: {
                              color: !field.isEditable
                                ? "black !important"
                                : "",
                            },
                          }}
                        /> */}

                        <DatePicker
                          label={
                            <>
                              {field.label}
                              {field.mandatory === 1 && isEditable && (
                                <span style={{ color: "red" }}> *</span>
                              )}
                            </>
                          }
                          value={
                            formDataState[field.actualFieldName]
                              ? moment
                                .utc(formDataState[field.actualFieldName], [
                                  "MMM DD YYYY h:mmA",
                                  "YYYY-MM-DDTHH:mm:ss.SSSZ",
                                ])
                                .isValid()
                                ? moment
                                  .utc(formDataState[field.actualFieldName], [
                                    "YYYY-MM-DDTHH:mm:ss.SSSZ",
                                    "MMM DD YYYY h:mmA",
                                  ])
                                  .toDate()
                                : null
                              : null
                          }
                          onSelectDate={(date) => {
                            if (!date) return;

                            // const isoDate = moment(date).utc().toISOString();
                            const isoDate = moment
                              .utc(moment(date).format("YYYY-MM-DD"))
                              .toISOString();
                            // const isoDate = date;
                            // const isoDate =
                            //   date
                            //     ? moment(date, [
                            //       "YYYY-MM-DDTHH:mm:ss.SSSZ",
                            //       "MMM DD YYYY h:mmA",
                            //     ])
                            //       .startOf("day")
                            //       .utc()
                            //       .toDate()
                            //     : null

                            setFormDataState({
                              ...formDataState,
                              [field.actualFieldName]: isoDate,
                            });
                            handleFieldChange(isoDate, field.actualFieldName);
                          }}
                          placeholder="Select Date"
                          // Don't use 'required' to prevent default error message
                          disabled={!isEditable}
                          styles={{
                            label: {
                              color: !isEditable ? "black !important" : "",
                            },
                          }}
                        />

                        {/* <DatePicker
                          label={<>{field.label}</>}
                          value={
                            formDataState[field.actualFieldName]
                              ? moment(formDataState[field.actualFieldName]).isValid()
                                ? moment(formDataState[field.actualFieldName]).toDate()
                                : null
                              : parseDate(field.controlValue)
                          }
                          onSelectDate={(date) => {
                            if (!date) return;

                            const isoDate = moment(date).toISOString();

                            setFormDataState({
                              ...formDataState,
                              [field.actualFieldName]: isoDate
                            });

                            handleFieldChange(isoDate, field.actualFieldName);
                          }}
                          placeholder="Select Date"
                          isRequired={field.mandatory === 1}
                          disabled={!field.isEditable}
                          styles={{
                            label: {
                              color: !field.isEditable ? "black !important" : "" // Ensure label stays black even when disabled
                            }
                          }}
                        /> */}
                      </div>
                    );

                  case "Text Area":
                    // Added By Madhuri.K On 09-10-2025 - Calculate character count for textarea
                    const textareaValue = formDataState[field.actualFieldName] !== undefined
                      ? formDataState[field.actualFieldName]
                      : field.controlValue || "";
                    const charCount = textareaValue?.length || 0;
                    const maxChars = 400;

                    return (
                      <div
                        key={index}
                        className={`col-md-4 mt-2 form-group row-${field.pageRoWNo}`}
                      >
                        <TextField
                          label={<>{field.label}</>}
                          placeholder={field.placeholder || ""} // Use a separate placeholder if needed
                          value={textareaValue}
                          onChange={(ev, newValue) => {
                            // Added By Madhuri.K On 09-10-2025 - Limit to 400 characters
                            const limitedValue = newValue?.slice(0, maxChars) || newValue;
                            setFormDataState({
                              ...formDataState,
                              [field.actualFieldName]: limitedValue,
                            });
                            handleFieldChange(limitedValue, field.actualFieldName);
                          }}
                          multiline
                          autoAdjustHeight
                          required={field.mandatory === 1}
                          disabled={!isEditable}
                          InputLabelProps={{
                            style: {
                              color: !isEditable ? "black !important" : "",
                            },
                          }}
                        />
                        {/* Added By Madhuri.K On 09-10-2025 - Character counter on new line */}
                        <div style={{
                          textAlign: 'right',
                          fontSize: '11px',
                          color: charCount >= maxChars ? '#d13438' : '#605e5c',
                          fontWeight: '500',
                          marginTop: '4px'
                        }}>
                          {charCount} / {maxChars} Characters
                        </div>
                      </div>
                    );

                  default:
                    return null;
                }
              })}
            </div>
          ))}
        </>
      );
    }
  };
  const handleWithdrawInitiative = async () => {
    // Step 1: Validate Mandatory Fields
    // if (!validateMandatoryFields()) {
    //   return; // Stop execution if mandatory fields are missing
    // }

    // Step 2: Identify Visible Fields
    const visibleFields = initiativeDetail?.data?.listInitiativeDetailEntity
      .filter((field) => field.applicable === 1) // Only visible fields
      .map((field) => field.actualFieldName);

    // Step 3: Define Numeric Fields & Filter Only Visible Numeric Fields
    const numericFields = [
      "ResourceEffort",
      "CustomFieldNumeric1",
      "CustomFieldNumeric2",
      "CustomFieldNumeric3",
      "CustomFieldNumeric4",
      "CustomFieldNumeric5",
    ];

    // Get only numeric fields that are visible
    const visibleNumericFields =
      initiativeDetail?.data?.listInitiativeDetailEntity
        .filter(
          (field) =>
            field.applicable === 1 && // Only visible fields
            numericFields.includes(field.actualFieldName) && // Only numeric fields
            field.controlType !== "Combo Box" // Exclude dropdowns
        )
        .map((field) => field.actualFieldName);

    // Step 4: Validate Numeric Fields
    // for (const fieldName of visibleNumericFields) {
    //   const fieldConfig =
    //     initiativeDetail?.data?.listInitiativeDetailEntity.find(
    //       (field) => field.actualFieldName === fieldName
    //     );

    //   if (!fieldConfig || fieldConfig.controlType === "Combo Box") {
    //     continue; // Skip dropdowns
    //   }

    //   const fieldValue = formDataState[fieldName]?.trim();

    //   // Check if the field is mandatory and empty
    //   if (fieldConfig.mandatory === 1 && (!fieldValue || fieldValue === "")) {
    //     toast.error(`'${fieldConfig.label}' should not be left blank.`);
    //     return;
    //   }

    //   // Check if the user entered a non-numeric value (even for non-mandatory fields)
    //   if (fieldValue && isNaN(fieldValue)) {
    //     toast.error(
    //       `Please enter only numeric values for '${fieldConfig.label}'.`
    //     );
    //     return;
    //   }

    //   // Ensure the number is positive
    //   if (fieldValue && Number(fieldValue) <= 0) {
    //     toast.error(
    //       `Please enter only positive numeric values for '${fieldConfig.label}'.`
    //     );
    //     return;
    //   }
    // }
    // Step 4: Validate Numeric Fields
    for (const fieldName of visibleNumericFields) {
      const fieldConfig =
        initiativeDetail?.data?.listInitiativeDetailEntity.find(
          (field) => field.actualFieldName === fieldName
        );

      if (!fieldConfig || fieldConfig.controlType === "Combo Box") {
        continue; // Skip dropdowns
      }

      const fieldValue = formDataState[fieldName];
      const trimmedValue = fieldValue?.toString().trim();

      // ✅ If the field is mandatory and empty
      // if (fieldConfig.mandatory === 1 && (!trimmedValue || trimmedValue === "")) {
      //   toast.error(`'${fieldConfig.label}' should not be left blank.`);
      //   return;
      // }

      // ✅ If optional and empty, skip validation
      if (
        fieldConfig.mandatory !== 1 &&
        (!trimmedValue || trimmedValue === "")
      ) {
        continue;
      }

      // ✅ If filled, check if numeric and positive
      // if (isNaN(trimmedValue)) {
      //   toast.error(
      //     `Please enter only numeric values for '${fieldConfig.label}'.`
      //   );
      //   return;
      // }

      // if (Number(trimmedValue) < 0) {
      //   toast.error(
      //     `Please enter only positive numeric values for '${fieldConfig.label}'.`
      //   );
      //   return;
      // }
    }

    // Step 5: Check if the title already exists
    const existingTitle =
      initiativeDetail?.data?.listInitiativeDetailEntity.find(
        (item) =>
          item.fieldName === "Title" &&
          item.controlValue === formDataState["Initiative Title"]
      );

    if (existingTitle) {
      toast.error("Initiative Title already exists");
      return; // Stop further execution
    }

    const url = `/api/InitiativeDetail/WithDrawInitiative?UserID=${userID}&IdeaID=${ideaID}`;

    try {
      const result = await AxiosInstance1.put(
        url,
        {} // Empty request body (if no data is being sent)
        // {
        //   headers: {
        //     Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
        //   },
        // }
      );

      // Check the API response
      if (result.data && result.data.data && result.data.data.length > 0) {
        const responseResult = result.data.data[0].result;

        // Case-sensitive check for "success"
        if (responseResult === "Success") {
          toast.success("Initiative Withdrawn successfully!", {
            position: "top-right",
            autoClose: 3000, // Close after 3 seconds
          });
          setRefresh1(!refresh);
        } else {
          // Show the result message in an error toast
          toast.error(responseResult);
        }
      } else {
        // Handle unexpected response format
        toast.error("Unexpected response from the server.");
      }
    } catch (err) {
      // Show error toast for network or server errors
      toast.error("Failed to withdraw initiative. Please try again.");
      console.error("Error withdrawing initiative:", err);
    }
  };

  // Added by Gauri to create a new function for pre-validation for Submit/Approve/Push Back on 07 Apr 2025
  const handlePreValidation = async (action) => {
    //Added by Parth.G
    if (!(action === "Push Back")) {
      if (!validateMandatoryFields()) return;
      if (!validateDateFields()) return;
      if (!validateNumericFields()) return;
    }

    setLoading(true);

    // Get the initiative title for messages
    const editedInitiative = initiativesData?.find(
      (init) => init.ideaIdPk === initiativesID
    );
    const initiativeTitle = editedInitiative ? editedInitiative.title : " ";

    const accessToken = sessionStorage.getItem("access_token");
    let validationUrl = "";

    // Determine which validation endpoint to use
    switch (action) {
      case "Submit":
        validationUrl = `/api/InitiativeWorflowActions/ValidateSubmit?IdeaID=${ideaID}`;
        break;
      case "Approve":
        validationUrl = `/api/InitiativeWorflowActions/ValidateApprove?IdeaID=${ideaID}&UserID=${userID}`;
        break;
      case "Reject":
      case "Push Back": // Handle "Push Back" as "Reject"
        validationUrl = `/api/InitiativeWorflowActions/ValidateReject?IdeaID=${ideaID}&UserID=${userID}`;
        break;
      default:
        setLoading(false);
        return false;
    }

    try {
      // Run validation
      const validationResponse = await AxiosInstance1.get(validationUrl, {
        // headers: {
        //   Authorization: `Bearer ${accessToken}`,
        // },
      });

      const validationResult = validationResponse?.data?.data?.[0]?.result;

      // If validation fails, show error and return false
      if (validationResult !== "Success") {
        const message = validationResult.replace(/\r\n/g, "\n");
        toast.error(message);
        setLoading(false);
        return false;
      }

      // If validation passes, return true
      setLoading(false);
      return true;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Validation error occurred.";
      toast.error(errorMessage);
      console.error("Error during validation:", error);
      setLoading(false);
      return false;
    }
  };

  // Simplify your submit action function since validation was already done
  const handleSubmitAction = async () => {
    setLoading(true);

    // Get the action and initiative title
    let action = modalTitle;
    if (action === "Push Back") {
      action = "Reject";
    }

    // Added by Gauri on 17 Nov 2025 - Check for comments FIRST before any other operations
    // This prevents the modal from closing due to page refresh when validation fails
    if (action !== "Quick Notification") {
      if (!comments || comments.trim() === "") {
        toast.error("Comment should not be left blank");
        setLoading(false);
        return; // Return early to prevent any refresh or modal close
      }
    }

    if (action === "Quick Notification") {
      if (!comments || comments.trim() === "") {
        toast.error("Comments should not be left blank");
        setLoading(false);
        return;
      }
      try {
        const url = `/api/QuickNotification/InsQuickNotification?IdeaId=${initiativesID}&UserId=${userID}&Remark=${encodeURIComponent(
          comments
        )}`;
        const response = await AxiosInstance1.post(url, {});
        const notificationEntity = response.data?.data?.NotificationEntity;

        if (response.data?.message === "Success") {
          if (
            Array.isArray(notificationEntity) &&
            notificationEntity.length > 0
          ) {
            // Check if all statuses are AlreadyExists
            const allAlreadyExists = notificationEntity.every(
              (item) => item.status === "AlreadyExists"
            );
            if (allAlreadyExists) {
              toast.info("Notification is already sent.");
            } else {
              toast.success("Notification sent successfully!");
            }
          } else {
            toast.success("Notification sent successfully!");
          }
          closeModal();
          setRefresh1((prev) => !prev);
        } else {
          toast.error(response.data?.message || "Failed to send Notification.");
        }
      } catch (error) {
        toast.error("An error occurred while sending Notification.");
        console.error(error);
      } finally {
        setLoading(false);
      }
      return;
    }

    //Added by parth.G on 16-04-2025 to handle submit action for submit button
    // Added by Gauri on 17 Nov 2025 - Only call handleSave after comments validation
    if (action === "Submit") {
      // action = "Reject";
      handleSave();
    }

    if (action === "Approve") {
      // action = "Reject";
      handleSave();
    }

    const editedInitiative = initiativesData?.find(
      (init) => init.ideaIdPk === initiativesID
    );
    const initiativeTitle = editedInitiative ? editedInitiative.title : " ";

    const accessToken = sessionStorage.getItem("access_token");

    try {
      // Commented by Gauri on 17 Nov 2025 - Comments validation moved to top
      // if (!comments || comments.trim() === "") {
      //   toast.error("Comment should not be left blank");
      //   setLoading(false);
      //   return;
      // }

      // Validation already done, proceed directly to action
      const response = await AxiosInstance1.put(
        `/api/InitiativeWorflowActions/WorkflowActions?IdeaID=${ideaID}&Action=${action}&UserID=${userID}&Comments=${comments}`,
        {}
        // {
        //   headers: {
        //     Authorization: `Bearer ${accessToken}`,
        //   },
        // }
      );

      // Modified by Gauri to add custom Toast Messages as per the Action on 16 Apr 2025
      let successMessage = "";
      switch (action) {
        case "Submit":
          // Modify By Madhuri.K On 25-04-2025
          successMessage = "Initiative Submitted Successfully";
          break;
        case "Approve":
          // Modify By Madhuri.K On 25-04-2025
          successMessage = "Initiative Approved Successfully";
          break;
        case "Reject":
          // Modify By Madhuri.K On 25-04-2025
          successMessage = "Initiative Pushback Successfully";
          break;
        default:
          successMessage = "Action completed successfully!";
      }

      toast.success(successMessage);

      // Handle email if needed
      const emailData =
        response?.data?.data?.listWorkflowActionResponseEntity[0];
      if (emailData?.message === "Success") {
        await sendSubmitActionEmail(emailData);
      }

      closeModal();
      setRefresh1(!refresh);
      handleGoBack();
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        "An error occurred while submitting the action.";
      toast.error(errorMessage);
      console.error("Error while submitting the action:", error);
    } finally {
      setLoading(false);
    }
  };

  // Added by Gauri to send mail after save on 25 Mar 2025
  const sendSubmitActionEmail = async (emailData) => {
    try {
      const emailUrl = `/api/EmailService/SendMail`;
      const params = {
        fromAddress: emailData.fromAddress,
        toAddress: emailData.toAddress,
        ccAddress: emailData.ccEmailAddress,
        subject: emailData.subject.replace(/\r\n/g, " "),
        body: emailData.body.replace(/\r\n/g, "<br>"),
        isHtml: 1,
      };

      const token = sessionStorage.getItem("access_token");
      const response = await AxiosInstance1.post(emailUrl, params, {
        // headers: {
        //   Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
        // },
      });

      if (response.status >= 200 && response.status < 300) {
        if (!response.data || response.data?.result === "Success") {
          toast.success("Email sent successfully!!");
        } else {
          toast.error("Failed to send Email.");
        }
      } else {
        toast.error(`Email failed with status: ${response.status}`);
      }
    } catch (error) {
      console.error("Error sending email:", error);
      toast.error("An error occurred while sending the email.");
    }
  };

  const renderDynamicButtons = () => {
    const linkAccessList =
      initiativeLinkAccess?.data?.listInitiativeLinkAccessEntity || [];
    const displayButtons = linkAccessList.filter(
      (button) => button.display === 1
    );

    // Added By Madhuri.K On 09-10-2025 - Define the desired order for action buttons (to appear at the end)
    const actionButtonOrder = [
      "Approve",
      "Push Back",
      "Submit",
      "Withdraw Initiative",
      "Save",
      "Save As Draft"
    ];

    // Commented By Madhuri.K On 09-10-2025 - Filter out Delegate and Back buttons
    const filteredButtons = displayButtons
      .filter((button) => button.linkName !== "Delegate" && button.linkName !== "Back");

    // Added By Madhuri.K On 09-10-2025 - Separate action buttons and other buttons to arrange proper sequence
    const otherButtons = filteredButtons.filter(
      (button) => !actionButtonOrder.includes(button.linkName)
    );

    // Filter only action buttons from the filtered list
    const actionButtons = filteredButtons.filter((button) =>
      actionButtonOrder.includes(button.linkName)
    );

    // Sort action buttons according to the defined order
    const sortedActionButtons = actionButtons.sort((a, b) => {
      return actionButtonOrder.indexOf(a.linkName) - actionButtonOrder.indexOf(b.linkName);
    });

    // Combine: other buttons first, then action buttons at the end
    const sortedButtons = [...otherButtons, ...sortedActionButtons];

    // Added By Madhuri.K On 09-10-2025 - Function to get icon and color for each button
    const getButtonStyle = (linkName) => {
      const styles = {
        "Approve": {
          icon: <CheckCircleIcon style={{ fontSize: "11px", marginRight: "2px" }} />,
          color: "#10b981",
          bgColor: "#f0fdf4",
          borderColor: "#86efac"
        },
        "Push Back": {
          icon: <UndoIcon style={{ fontSize: "11px", marginRight: "2px" }} />,
          color: "#f59e0b",
          bgColor: "#fffbeb",
          borderColor: "#fde68a"
        },
        "Submit": {
          icon: <SendIcon style={{ fontSize: "11px", marginRight: "2px" }} />,
          color: "#3b82f6",
          bgColor: "#eff6ff",
          borderColor: "#93c5fd"
        },
        "Withdraw Initiative": {
          icon: <CancelIcon style={{ fontSize: "11px", marginRight: "2px" }} />,
          color: "#ef4444",
          bgColor: "#fef2f2",
          borderColor: "#fecaca"
        },
        "Save": {
          icon: <SaveIcon style={{ fontSize: "11px", marginRight: "2px" }} />,
          color: "#8b5cf6",
          bgColor: "#faf5ff",
          borderColor: "#d8b4fe"
        },
        "Save As Draft": {
          icon: <DraftsIcon style={{ fontSize: "11px", marginRight: "2px" }} />,
          // Commented and Modified by Gauri on 12 Nov 2025
          // color: "#6b7280", 
          // bgColor: "#f9fafb",
          // borderColor: "#d1d5db"
          color: "#ff874e",
          bgColor: "#fff5ed",
          borderColor: "#ff874e"
        }
      };
      return styles[linkName] || { icon: null, color: "#000", bgColor: "transparent", borderColor: "transparent" };
    };

    // Map through sorted buttons and create button elements
    const buttonTexts = sortedButtons.map((button, index) => {
      // Added By Madhuri.K On 09-10-2025 - Rename "Prioritization CheckList" to "CheckList"
      const displayName = button.linkName === "Prioritization CheckList"
        ? "CheckList"
        : button.linkName;

      const { icon, color, bgColor, borderColor } = getButtonStyle(button.linkName);
      const isActionButton = actionButtonOrder.includes(button.linkName);

      return (
        <span
          key={index}
          onClick={() => handleButtonClick(button.linkName)}
          style={{
            cursor: "pointer",
            fontSize: isActionButton ? "10px" : "0.75em",
            color: isActionButton ? color : "#000",
            display: isActionButton ? "inline-flex" : "inline",
            alignItems: isActionButton ? "center" : "normal",
            gap: isActionButton ? "2px" : "0",
            padding: isActionButton ? "4px 7px" : "0",
            backgroundColor: isActionButton ? bgColor : "transparent",
            borderRadius: isActionButton ? "4px" : "0",
            fontWeight: isActionButton ? "500" : "normal",
            border: isActionButton ? `1px solid ${borderColor}` : "none",
            transition: "all 0.3s ease",
            whiteSpace: "nowrap",
            flexShrink: 0
          }}
          onMouseEnter={(e) => {
            if (isActionButton) {
              e.currentTarget.style.opacity = "0.8";
              e.currentTarget.style.transform = "translateY(-1px)";
            }
          }}
          onMouseLeave={(e) => {
            if (isActionButton) {
              e.currentTarget.style.opacity = "1";
              e.currentTarget.style.transform = "translateY(0)";
            }
          }}
        >
          {isActionButton && icon}
          {displayName}
        </span>
      );
    });


    // Show Delegated Access icon only if there is a "Delegate" button with display === 1
    const showDelegatedAccess = displayButtons.some(
      (button) => button.linkName === "Delegate" && button.display === 1
    );

    // Commented by Gauri to fix Workflow Details button always showing on 14 Nov 2025
    // if (buttonTexts.length === 0 && !showDelegatedAccess) {
    //  return null;
    // }

    return (
      <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", width: "100%" }}>
        {/* Code Changed By Madhuri.K On 09-10-2025 */}
        <Stack horizontal tokens={{ childrenGap: 3 }} verticalAlign="center" horizontalAlign="end" styles={{ root: { flexWrap: "nowrap", gap: "2px", minWidth: 0 } }}>
          <span
            onClick={handleOpenDetailsModal}
            style={{
              cursor: "pointer",
              display: "inline-flex",
              alignItems: "center",
              gap: "2px",
              padding: "4px 7px",
              backgroundColor: "#f0f4ff",
              color: "#2b55ce",
              borderRadius: "4px",
              fontSize: "10px",
              fontWeight: "500",
              border: "1px solid #d0dff7",
              transition: "all 0.3s ease",
              whiteSpace: "nowrap",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#e3eaff";
              e.currentTarget.style.borderColor = "#2b55ce";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#f0f4ff";
              e.currentTarget.style.borderColor = "#d0dff7";
            }}
          >
            <TimelineIcon style={{ fontSize: "11px" }} />
            {/* Commented and Modified by Gauri on 12 Nov 2025 */}
            {/* Initiative Details */}
            Workflow Details
          </span>
          {/* Code Changed By Madhuri.K On 09-10-2025 */}
          {showDelegatedAccess && (
            <>
              <span style={{ color: "#ccc", fontSize: "9px" }}>|</span>
              <span
                onClick={handleOpenDelegatedToModal}
                style={{
                  cursor: "pointer",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "2px",
                  padding: "4px 7px",
                  backgroundColor: "#fff4f0",
                  color: "#d97706",
                  borderRadius: "4px",
                  fontSize: "10px",
                  fontWeight: "500",
                  border: "1px solid #fed7aa",
                  transition: "all 0.3s ease",
                  whiteSpace: "nowrap",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "#ffedd5";
                  e.currentTarget.style.borderColor = "#d97706";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = "#fff4f0";
                  e.currentTarget.style.borderColor = "#fed7aa";
                }}
              >
                <PersonAddIcon style={{ fontSize: "11px" }} />
                Delegate Access
              </span>
            </>
          )}
          {buttonTexts.length > 0 && (
            <>
              <span style={{ color: "#ccc", fontSize: "9px" }}>|</span>
              {buttonTexts.reduce((prev, curr, idx) =>
                idx === 0 ? [curr] : [...prev, <span key={`sep-${idx}`} style={{ color: "#ccc", fontSize: "9px" }}>|</span>, curr]
                , [])}
            </>
          )}
        </Stack>
        <div className="col-sm-12 text-end form-group mt-1">
          <label className="form-label IM_label">
            (<span style={{ color: "red" }}>*</span> Mandatory)
          </label>
        </div>
      </div>
    );
  };

  const handleDrawerOpen = () => setDrawerOpen(true);
  const handleDrawerClose = () => setDrawerOpen(false);
  const handleButtonClick = async (linkName) => {
    console.log("handleButtonClick", linkName);

    // Added by Gauri to handle workflow action buttons that need validation on 07 Apr 2025
    if (
      ["Submit", "Approve", "Push Back", "Quick Notification"].includes(
        linkName
      )
    ) {
      // Run validation before opening modal
      // Added by Shivam to add Quick Notification button that doesn't need validation on 08 Apr 2025
      // const isValid = await handlePreValidation(linkName);
      const isValid =
        linkName === "Quick Notification"
          ? true
          : await handlePreValidation(linkName);
      if (isValid) {
        // Only open modal if validation passes
        setModalTitle(linkName);
        setIsModalOpen(true);
      }
      return; // Exit function after handling these special cases
    }

    switch (linkName) {
      case "Save":
      case "Save As Draft":
        handleSave(linkName);
        break;
      case "Withdraw Initiative":
        handleWithdrawInitiative();
        break;
      // case "Submit":
      // case "Approve":
      // case "Push Back":
      case "Show History": // Added Reject option
        handleOpenDrawer(initiativesID); // Open the modal with the respective action
        break;
      case "Back":
        handleGoBack();
      case "Workflow Information":
        handleDrawerOpen();
        break;
      case "Prioritization CheckList":
        setOpen(true);
        break;
      case "Manage Workflow":
        setOpen1(true);
        break;
      default:
        break;
    }
  };

  // Added by Gauri on 20 Nov 2025 - Common calloutProps for all dropdowns
  const commonCalloutProps = {
    // Use bottomAutoEdge which tries to open downward first, then automatically adjusts upward if needed
    directionalHint: DirectionalHint.bottomAutoEdge,
    // Set max height to prevent dropdown from being too large
    calloutMaxHeight: 250,
    // Ensure dropdown stays within viewport bounds
    bounds: typeof window !== 'undefined' ? {
      top: 0,
      left: 0,
      bottom: window.innerHeight,
      right: window.innerWidth
    } : undefined
  };

  return (
    <div className="container-fluid mt-3">
      <div
        style={{
          width: "100%",
          paddingBottom: "5px",
          marginBottom: "10px"
        }}
      >
        <div
          className="d-flex justify-content-end"
          style={{
            flexWrap: "nowrap",
            gap: "0.2rem",
            minWidth: "max-content"
          }}
        >
          {renderDynamicButtons()}
        </div>
      </div>
      <form>
        <div>{renderFormElements()}</div>
      </form>
      {isModalOpen && (
        <div className={classNames.modalWrapper}>
          <div className={classNames.modal}>
            <div
              className={classNames.header}
              style={{
                backgroundColor: "#f0f0f0",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "0.5rem 1rem",
              }}
            >
              {/* Added by Gauri On 17 Nov 2025 to show Quick Notification To Next Approval instead of Quick Notification */}
              <h6>{modalTitle === "Quick Notification" ? "Quick Notification To Next Approval" : modalTitle}</h6>

              <IconButton
                onClick={closeModal}
                style={{
                  position: "absolute",
                  top: "20px",
                  right: "20px",
                  border: "none",
                  outline: "none",
                  cursor: "pointer",
                }}
              >
                <Tooltip title="Close">
                  <CloseIcon />
                </Tooltip>
              </IconButton>
            </div>
            <div className={classNames.body}>
              <TextField
                label={`Comments for ${modalTitle === "Quick Notification"
                    ? "Next Approval"
                    : modalTitle
                  }`}
                multiline
                rows={4}
                value={comments}
                //Added by Shivam for maxlength 250 char when modalTitle is Quick Notification on 08/07/25
                inputProps={
                  modalTitle === "Quick Notification" ? { maxLength: 250 } : {}
                }
                onChange={(ev, newValue) => {
                  if (
                    modalTitle === "Quick Notification" &&
                    newValue.length > 250
                  ) {
                    setComments(newValue.slice(0, 250));
                  } else {
                    setComments(newValue);
                  }
                }}
              // onChange={(ev, newValue) => setComments(newValue)}
              />
            </div>
            <div className={classNames.footer}>
              <PrimaryButton onClick={handleSubmitAction} disabled={loading}>
                {loading
                  ? "Submitting..."
                  : modalTitle === "Quick Notification"
                    // Added by Gauri On 17 Nov 2025 to show Notify to Next Approval instead of Notify
                    // ? "Notify"
                    ? "Notify to Next Approval"
                    : modalTitle}
              </PrimaryButton>
            </div>
          </div>
        </div>
      )}

      {openDetailsModal && (
        <InitiativeDetailsModal
          open={openDetailsModal}
          handleClose={handleClose}
          initiativesID={initiativesID}
        />
      )}
      {/* Added By Madhuri.K On 08-07-2025 */}
      {DelegatedToModal && (
        <DelegatedAccessModal
          open={DelegatedToModal}
          handleClose={handleDelegatedClose}
          initiativesID={initiativesID}
          NodID={natureofDemandID}
          NodRevID={natureOfDemandRevisionID}
          initiativesData={initiativesData}
          natureofDemand={natureofDemand}
        />
      )}
      <PrioritizationCheckList
        prioritizationCheckList={prioritizationCheckList}
        open={open}
        setOpen={setOpen}
        setRefresh1={setRefresh1}
        refresh={refresh}
      />
      <InitiativeHistoryDrawer12
        initiativeId={initiativesID}
        open={isDrawerOpen}
        onClose={handleCloseDrawer}
      />
      {/* Passed initiativesData by Gauri for manage workflow stages on 24 Mar 2025 */}
      <WorkflowDrawer
        initiativesID={initiativesID}
        initiativesData={initiativesData}
        open={open1}
        setOpen={setOpen1}
        handleGoBack={handleGoBack}
      />
      <ActionItems
        initiativeActioItems={initiativeActioItems}
        open={aopen}
        setOpen={setAOpen}
      />
      <WorkflowInfo
        open={drawerOpen}
        onClose={handleDrawerClose}
        initiativesID={initiativesID}
      />
    </div>
  );
}

export default BasicDetailEdit;
